import { BlockSelectField } from '@common/components/FormElements/BlockSelectField';
import moment from 'moment';
import { Controller, FieldPath, useFormContext } from 'react-hook-form';
import { RoomExtraOption } from 'shared-types/Room';
import { RoomRateFormValues } from '../../../../RoomRateForm.schema';

type PerDateTimeRangeOption = RoomExtraOption & {
  startDate?: string;
  endDate?: string;
  startTime?: string;
  endTime?: string;
};

const optionsForPerDateTimeRange = (options: PerDateTimeRangeOption[]) =>
  options.map((option, index) => {
    const startDate = moment(option.startDate).format('MMM DD');
    const endDate = moment(option.endDate).format('MMM DD');
    const dateString = startDate === endDate ? startDate : `${startDate} - ${endDate}`;
    return {
      label: `${dateString} : ${option?.startTime?.substr(0, 5)} - ${option?.endTime?.substr(
        0,
        5
      )}`,
      value: index,
    };
  });

type SelectOption = { label: string; value: number };

export const PerDateTimeRange = ({ id, options }: { id: number; options: RoomExtraOption[] }) => {
  const { control } = useFormContext<RoomRateFormValues>();
  const opts = optionsForPerDateTimeRange(options as PerDateTimeRangeOption[]);

  return (
    <Controller
      control={control}
      name={`extras.${id}.option` as FieldPath<RoomRateFormValues>}
      render={({ field: { value, onChange } }) => (
        <BlockSelectField
          options={opts}
          value={opts.find((o) => o.value === value) ?? null}
          onChange={(selected: SelectOption) => onChange(selected?.value ?? null)}
        />
      )}
    />
  );
};
